import { FamlaServices } from "../services"
import { config } from "../services/config"
import { msalInstance } from "../auth/msalInstance"
import { clearAuthCookies } from "./authUtils"
import { clearAnalysisDraft } from "./analysisDraftStorage"
import { clearMarketplaceFlow } from "./marketplaceSession"
import { Routes } from "../routes"
import { logout, persistor, store } from "../stores"

/**
 * Déconnexion complète (identique à l’ancien menu Dropdown) — store Redux + persistance + redirection.
 */
export async function performAppLogout(): Promise<void> {
    FamlaServices("api_host", "/auth/logout", "GET", "", "")
        .then(() => console.log("[Logout] Backend logout successful"))
        .catch((error) => console.warn("[Logout] Backend logout failed:", error))

    clearAuthCookies()

    localStorage.removeItem("famla_first_login_done")
    localStorage.removeItem("famla_employee_onboarding_guidance_shown")
    localStorage.removeItem("famla_employee_onboarding_guidance_dismissed")
    localStorage.removeItem("tutorial_home_auto_started")
    localStorage.removeItem("tutorial_home_completed")
    localStorage.removeItem("tutorial_processCreate_auto_started")
    localStorage.removeItem("tutorial_processCreate_completed")
    localStorage.removeItem("tutorial_sampleProcess_auto_started")
    localStorage.removeItem("tutorial_sampleProcess_completed")
    localStorage.removeItem("tutorial_campaigns_completed")
    localStorage.removeItem("tutorial_analysis_completed")
    localStorage.removeItem("tutorial_flowchart_completed")
    localStorage.removeItem("tutorial_admin_completed")
    localStorage.removeItem("tutorial_participants_completed")
    sessionStorage.removeItem("api_first_login")
    clearMarketplaceFlow()
    clearAnalysisDraft()

    // Marquer la déconnexion Microsoft manuelle pour éviter la reconnexion automatique
    sessionStorage.setItem("microsoft_manual_logout", "true")

    try {
        await msalInstance.clearCache()
    } catch (e) {
        console.warn("[Logout] Impossible de purger le cache Microsoft (MSAL):", e)
    }

    store.dispatch(logout())
    await persistor.purge()
    sessionStorage.removeItem("st_portal_user")

    if (config.app.stOnlyMode) {
        window.location.href = "/st-portal"
    } else {
        window.location.href = Routes.AUTH_LOGIN
    }
}
